import { useTranslate } from 'hooks/useTranslate';
import downloadDocument from 'utils/downloadDocument';
import { useCommunicationDetailsPage } from '../context/CommunicationDetailsPageContext';

const CommunicationAttachmentsSection = () => {
  const { t } = useTranslate();

  const { data } = useCommunicationDetailsPage();

  const { communication } = data;

  const hasAttachments = (communication?.attachments ?? []).length > 0;

  return (
    <div className="attach-files m-0">
      <ul className="attach-list flex-column justify-content-center px-2 pt-2">
        {data.attachedDocuments?.map((attachment: any) => (
          <li className="attach-item d-flex w-100 mb-1" key={attachment._id}>
            <em className="icon ni ni-file-doc" />
            <span>{attachment?.name}</span>
          </li>
        ))}
      </ul>

      <div className="attach-foot">
        <span className="attach-info">
          {communication?.attachments?.length}
          &nbsp;
          {t('FilesAttached')}
        </span>

        <span
          className={`attach-download link ${
            !hasAttachments ? 'is-disable' : ''
          }`}
          onClick={() => {
            downloadDocument({
              multiple: true,
              documents: data.attachedDocuments,
            });
          }}
        >
          <em
            className={`icon ni ni-download text-primary cursor-pointer ${
              !hasAttachments ? 'is-disable' : ''
            }`}
          />
          <span className={`${!hasAttachments ? 'is-disable' : ''}`}>
            {t('DownloadAll')}
          </span>
        </span>
      </div>
    </div>
  );
};

export default CommunicationAttachmentsSection;
